module.exports = "<router-outlet>\r\n    <app-spinner></app-spinner>\r\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main